<workspace-breadcrumb />

<div class="relative min-h-[10rem]">
  <go-back class="w-full flex-start flex sm:hidden mb-8"></go-back>
  @if (referralAsUserResource.status() === 'error' || invitationResource.status() === 'error') {
    @if (referralAsUserResource.status() === 'error') {
      <app-resource-load-error
        data-resource="user"
        message="my-referrals.userLoadError"
        (retry)="referralAsUserResource.reload()"
      />
    }
    @if (invitationResource.status() === 'error') {
      <app-resource-load-error
        data-resource="invitation"
        message="my-referrals.invitationLoadError"
        (retry)="invitationResource.reload()"
      />
    }
  } @else if (isLoading() || inviteIsLoading()) {
    <div class="relative min-h-[10rem]">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (user() && invite()) {
    <div
      class="px-[2.5rem] py-[3rem] flex md:flex-row flex-col items-center md:items-start gap-[2.25rem] card relative mb-6"
    >
      <div class="size-[11.25rem]">
        <app-user-avatar-v2 [user]="invitationAsUser()" [style.--avatar-initials-font-size]="'4rem'" />
      </div>
      <div class="flex flex-1 flex-col gap-[1.5rem]">
        <span class="text-[1.9375rem]/[160%] font-bold text-[#2C3035]">{{
          invitationAsUser()?.userObj?.full_name
        }}</span>
        <div class="flex flex-col gap-[0.5rem]">
          <div class="flex justify-between gap-2">
            <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ 'myGanarbols.currentStatus' | translate }}</span>
            <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{
              referralStatusLocaleKey() ? (referralStatusLocaleKey() | translate) : referral()?.status || '-'
            }}</span>
          </div>
          <div class="flex justify-between gap-2">
            <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ 'referral.contact-method' | translate }}</span>
            <span class="text-[#2C3035] text-[0.9375rem]/[160%]">
              {{ contactMethodLocaleKey() ? (contactMethodLocaleKey() | translate) : '-' }}
            </span>
          </div>
          @if (emailContact()) {
            <div class="flex justify-between gap-2">
              <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ 'my-referrals.email' | translate }}</span>
              <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ emailContact() }}</span>
            </div>
          }
          @if (phoneContact()) {
            <div class="flex justify-between gap-2">
              <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ 'my-referrals.phoneNumber' | translate }}</span>
              <span class="text-[#2C3035] text-[0.9375rem]/[160%]">{{ phoneContact() }}</span>
            </div>
          }
        </div>
      </div>
      <button
        class="absolute top-8 right-8"
        nz-button
        nzType="text"
        nz-popconfirm
        appHideTooltipOnScroll
        [nzIcon]="null"
        nzPopconfirmPlacement="bottomRight"
        nzPopconfirmArrowPointAtCenter
        [nzPopconfirmOverlayClassName]="'action-menu-popconfirm-overlay'"
        [nzPopconfirmTitle]="seedMenu"
      >
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
              d="M12.25 7.5C11.2835 7.5 10.5 6.7165 10.5 5.75C10.5 4.7835 11.2835 4 12.25 4C13.2165 4 14 4.7835 14 5.75C14 6.7165 13.2165 7.5 12.25 7.5ZM12.25 13.5C11.2835 13.5 10.5 12.7165 10.5 11.75C10.5 10.7835 11.2835 10 12.25 10C13.2165 10 14 10.7835 14 11.75C14 12.7165 13.2165 13.5 12.25 13.5ZM10.5 17.75C10.5 18.7165 11.2835 19.5 12.25 19.5C13.2165 19.5 14 18.7165 14 17.75C14 16.7835 13.2165 16 12.25 16C11.2835 16 10.5 16.7835 10.5 17.75Z"
              fill="#505760"
            />
          </svg>
        </i>
      </button>
    </div>
    @if (referralResource.status() === 'error') {
      <app-resource-load-error
        data-resource="referral"
        message="my-referrals.referralLoadError"
        (retry)="referralResource.reload()"
      />
    }
    @if (timelineResource.status() === 'error') {
      <app-resource-load-error
        data-resource="timeline"
        message="my-referrals.contactHistoryLoadError"
        (retry)="timelineResource.reload()"
      />
    }
    @if (remindersResource.status() === 'error') {
      <app-resource-load-error
        data-resource="reminders"
        message="my-referrals.remindersLoadError"
        (retry)="remindersResource.reload()"
      />
    }
    @if (referralResource.hasValue()) {
      <!-- steps -->
      <div class="p-6 flex flex-col card mb-6">
        <span class="block mb-1 text-[1rem]/[160%] md:text-[1.125rem]/[160%] text-[#003555] font-bold">{{
          'my-referrals.yourReferralsFirstSteps' | translate
        }}</span>
        <span class="block mb-6 text-[1rem]/[160%] md:text-[1.125rem]/[160%] text-[#007DCB]">{{
          (isGanasocio() ? 'my-referrals.seedsBecomeGanasocio' : 'my-referrals.seedsBecomeGanacuates') | translate
        }}</span>
        @if (timelineResource.hasValue()) {
          <app-steps-v2 class="block w-full" [steps]="steps()" />
        }
      </div>
      @if (isGanasocio()) {
        <!-- WhatsApp button only for Ganasocio -->
        @if (canShareWhatsapp()) {
          <korviu-button
            [style.--button__border-radius]="'0.375rem'"
            class="h-[3.3rem] w-full"
            color="tertiary"
            (onclick)="openWhatsAppDesktop()"
          >
            <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">
              {{ 'my-referrals.whatsAppMessage' | translate }}
            </span>
          </korviu-button>
        } @else if (isPendingApproval()) {
          <korviu-button
            [style.--button__border-radius]="'0.375rem'"
            class="h-[3.3rem] w-full"
            color="tertiary"
            [disabled]="true"
          >
            <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">
              {{ 'referral.verifyInvite.pendingApprovalHeader' | translate }}
            </span>
          </korviu-button>
        }
      } @else {
        <!-- timeline -->
        <div class="card p-6 flex flex-col gap-8">
          <div class="flex gap-4 items-center">
            <span class="text-[1.375rem]/[160%] text-[#222528] font-bold">{{
              'my-referrals.contactHistory' | translate
            }}</span>
            @if (timelineResource.hasValue() && remindersResource.hasValue() && showItsBeenWhile()) {
              <app-tag type="info">{{ 'my-referrals.itsBeenWhile' | translate }}</app-tag>
            }
            @if (remindersResource.hasValue() && allRemindersSent()) {
              <app-tag type="info">{{ 'my-referrals.allRemindersSent' | translate }}</app-tag>
            }
          </div>
          <div>
            @if (timelineResource.hasValue() && remindersResource.hasValue()) {
              <app-timeline-v2 [events]="timelineEvents()" />
            }
          </div>
          <div class="flex flex-col md:flex-row gap-4 items-center">
            @if (remindersResource.hasValue()) {
              <korviu-button
                class="h-[3.3rem] w-full"
                [style.--button__border-radius]="'0.375rem'"
                color="tertiary"
                [disabled]="!canSendReminder()"
                (onclick)="sendReminder()"
              >
                <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">
                  {{ (canSendReminder() ? reminderButtonLocale() : 'my-referrals.lastReminderSent') | translate }}
                </span>
              </korviu-button>
            }
            @if (canShareWhatsapp()) {
              <korviu-button
                class="h-[3.3rem] w-full"
                color="ghost"
                [style.--button__border-radius]="'0.375rem'"
                (onclick)="openWhatsAppDesktop()"
              >
                <span class="text-[1rem]/[160%] md:text-[1.125rem]/[160%]">
                  {{ 'my-referrals.whatsAppMessage' | translate }}
                </span>
              </korviu-button>
            }
          </div>
        </div>
      }
    }
  } @else {
    <app-resource-load-error
      message="my-referrals.invitationLoadError"
      (retry)="invitationResource.reload(); referralAsUserResource.reload()"
    />
  }
</div>

<ng-template #seedMenu>
  <div class="action-menu-popconfirm">
    <button nz-button nzType="text" class="p-0" (click)="onEditInvitationDetails()">
      <div class="flex flex-row gap-2">
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M20.9519 2.5481C19.5543 1.15058 17.2885 1.15064 15.8911 2.54825L3.94103 14.4997C3.5347 14.9061 3.2491 15.4172 3.116 15.9762L2.02041 20.5777C1.96009 20.8311 2.03552 21.0976 2.21968 21.2817C2.40385 21.4659 2.67037 21.5413 2.92373 21.481L7.52498 20.3855C8.08418 20.2523 8.59546 19.9666 9.00191 19.5601L20.952 7.60861C22.3493 6.21112 22.3493 3.9455 20.9519 2.5481ZM16.9518 3.60884C17.7634 2.79709 19.0795 2.79705 19.8912 3.60876C20.7028 4.4204 20.7029 5.73632 19.8913 6.54801L19 7.43946L16.0606 4.50012L16.9518 3.60884ZM15 5.56084L17.9394 8.50018L7.94119 18.4995C7.73104 18.7097 7.46668 18.8574 7.17755 18.9263L3.76191 19.7395L4.57521 16.3237C4.64402 16.0346 4.79168 15.7704 5.00175 15.5603L15 5.56084Z"
              fill="#2C3035"
            />
          </svg>
        </i>
        <span class="font-medium text-base">
          {{ 'buildYourNetwork.editInvitationDetails' | translate }}
        </span>
      </div>
    </button>
    <button
      nz-button
      nzType="text"
      class="p-0 action-menu-popconfirm__danger"
      [disabled]="!referral()?.id"
      (click)="onDeleteAccountClick()"
    >
      <div class="flex flex-row gap-2">
        <i nz-icon>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 5.5H14C14 4.39543 13.1046 3.5 12 3.5C10.8954 3.5 10 4.39543 10 5.5ZM8.5 5.5C8.5 3.567 10.067 2 12 2C13.933 2 15.5 3.567 15.5 5.5H21.25C21.6642 5.5 22 5.83579 22 6.25C22 6.66421 21.6642 7 21.25 7H19.9309L18.7589 19.1112C18.5729 21.0334 16.9575 22.5 15.0263 22.5H8.97369C7.04254 22.5 5.42715 21.0334 5.24113 19.1112L4.06908 7H2.75C2.33579 7 2 6.66421 2 6.25C2 5.83579 2.33579 5.5 2.75 5.5H8.5ZM10.5 10.25C10.5 9.83579 10.1642 9.5 9.75 9.5C9.33579 9.5 9 9.83579 9 10.25V17.75C9 18.1642 9.33579 18.5 9.75 18.5C10.1642 18.5 10.5 18.1642 10.5 17.75V10.25ZM14.25 9.5C14.6642 9.5 15 9.83579 15 10.25V17.75C15 18.1642 14.6642 18.5 14.25 18.5C13.8358 18.5 13.5 18.1642 13.5 17.75V10.25C13.5 9.83579 13.8358 9.5 14.25 9.5ZM6.73416 18.9667C6.84577 20.12 7.815 21 8.97369 21H15.0263C16.185 21 17.1542 20.12 17.2658 18.9667L18.4239 7H5.57608L6.73416 18.9667Z"
              fill="#2C3035"
            />
          </svg>
        </i>
        <span class="font-medium text-base">{{ 'buildYourNetwork.remove' | translate }}</span>
      </div>
    </button>
  </div>
</ng-template>
